var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaginationLeft = function SvgPaginationLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.762 12.412-1.786 1.773L0 7.093 6.976 0l1.786 1.773-5.257 5.32 5.257 5.32Z",
    fill: "#F6F3ED"
  })));
};
export default SvgPaginationLeft;